export default __webpack_public_path__ + "static/media/broken-image-fallback-gr.e24ed716.svg";